(() => {
  const initChoiceProductModal = () => {
    const modal = document.querySelector('[data-choice-product-modal]');
    if (!modal || modal.dataset.initialized === 'true') return;

    modal.dataset.initialized = 'true';

    const params = new URLSearchParams(window.location.search);
    if (!params.has('choice')) return;

    modal.hidden = false;
    document.body.classList.add('choice-product-modal-open');

    const firstLink = modal.querySelector('.choice-product-modal__link');
    if (firstLink) firstLink.focus({ preventScroll: true });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('choice-product-modal-open');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChoiceProductModal, { once: true });
  } else {
    initChoiceProductModal();
  }
})();
